module.exports = __webpack_public_path__ + "static/media/wcb-1.93f317a4.png";